import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  AssociacaoGrupoCarteiraTabComponent
} from "./associacao-grupo-carteira-tab/associacao-grupo-carteira-tab.component";
import {MatTabsModule} from "@angular/material/tabs";
import {
  AssociacaoGrupoCarteiraStepper
} from "./associacao-grupo-carteira-stepper/associacao-grupo-carteira-stepper.component";
import {MatStepperModule} from "@angular/material/stepper";
import {SharedModule} from "../shared/shared.module";
import {
  SelecaoGrupoCarteiraComponent
} from "./associacao-grupo-carteira-stepper/selecao-grupo-carteira/selecao-grupo-carteira.component";
import {AutocompleteModule} from "../shared/components/autocomplete/autocomplete.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {PaginationMapsModule} from "maps-angular-components";
import {MatButtonModule} from "@angular/material/button";
import {
  SelecaoCarteiraComponent
} from "./associacao-grupo-carteira-stepper/selecao-carteira/selecao-carteira.component";
import { MatDialogModule } from '@angular/material/dialog';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AssociacaoGrupoCarteiraGerenciadorComponent } from './associacao-grupo-carteira-gerenciador/associacao-grupo-carteira-gerenciador.component';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ModalDeletarAssociacaoGrupoCarteiraComponent } from "src/app/associacao-grupo-carteira/modal-deletar-associacao-grupo-carteira/modal-deletar-associacao-grupo-carteira.component";
import { MatMenuModule } from "@angular/material/menu";

@NgModule({
  declarations: [
    AssociacaoGrupoCarteiraTabComponent,
    AssociacaoGrupoCarteiraStepper,
    SelecaoGrupoCarteiraComponent,
    SelecaoCarteiraComponent,
    AssociacaoGrupoCarteiraGerenciadorComponent,
    ModalDeletarAssociacaoGrupoCarteiraComponent,
  ],
    imports: [
        CommonModule,
        MatTabsModule,
        MatStepperModule,
        SharedModule,
        AutocompleteModule,
        ReactiveFormsModule,
        PaginationMapsModule,
        MatButtonModule,
        MatDialogModule,
        AutocompleteLibModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
    ]
})
export class AssociacaoGrupoCarteiraModule {
}
